export default __webpack_public_path__ + "static/media/g3.d0bc84a2.webp";